import * as types from "./PredefinedGoalsTypes";

const initialState = {
    predefinedGoalsList: [],
    selectedPredefinedGoal: null,
    loading: false,
    error: null
};

const PredefinedGoalsReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get Predefined Goals List
        case types.GET_PREDEFINED_GOALS_LIST_SUCCESS:
            return {
                ...state,
                predefinedGoalsList: action.payload.list || [],
                loading: false,
                error: null
            };
        case types.GET_PREDEFINED_GOALS_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Get Predefined Goal by ID
        case types.GET_PREDEFINED_GOAL_BY_ID_SUCCESS:
            return {
                ...state,
                selectedPredefinedGoal: action.payload,
                loading: false,
                error: null
            };
        case types.GET_PREDEFINED_GOAL_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Clear Predefined Goals State
        case types.CLEAR_PREDEFINED_GOALS_STATE:
            return initialState;

        default:
            return state;
    }
};

export default PredefinedGoalsReducer;